import { Outlet } from "react-router-dom";
import SidebarNav from "../../../components/Settings/SidebarNav";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import SideBarRender from "../../../components/Settings/SideBarRender";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useEffect, useState } from "react";
import DeptUsersView from "./DeptUsersView";

const OrgDepartments = () => {
  const { selectedOrgDepts } = useDepartmentHook();
const [sidebaritems, setsidebaritems] =useState([])
  const { setselectedDept, setSidebarRenderView, setLoading } =
    useStateSetter();

  useEffect(() => {
    setSidebarRenderView(<DeptUsersView />);
  }, []);

  
  return (
    <div className="h-full w-screen flex mt-4 ">
      <div className="w-[30vw] px-14 h-full">
        <SidebarNav
          title="Departments"
          items={selectedOrgDepts ? selectedOrgDepts.map((i) => {
            return {
              title: i.deptName,
              onclick: () => {
                setselectedDept(i);
              },
            };
          }):[]}
        />
      </div>

      <div className=" w-[70vw] flex justify-start items-start ">
        <SideBarRender />
      </div>
    </div>
  );
};

export { OrgDepartments };
